export default "__VITE_ASSET__Cmo3gqVK__"